export default __webpack_public_path__ + "static/media/noexpl_015_EN.64d2cea7.png";